<template>
  <v-row class="fill-height" align="center" justify="center">
    <v-col cols="12" xs="8" sm="8" md="6" lg="4" xl="2" class="pa-0">
      <v-card class="pa-6" elevation="4">
        <v-card-title class="d-flex flex-column align-center">
          <v-icon size="64" color="#1C1133" class="mb-4">lock_reset</v-icon>
          <h2 class="text-h5 text-center font-weight-bold secondary--text mb-2 title-text">{{$t('reset_password')}}</h2>
          <p class="text-subtitle-1 text-center grey--text">{{$t('enter_new_password')}}</p>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" class="mt-4">
            <v-text-field
              v-model="newPassword"
              :label="$t('new_password')"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :rules="passwordRules"
              class="mb-2"
            ></v-text-field>

            <v-text-field
              v-model="confirmPassword"
              :label="$t('confirm_password')"
              :type="showConfirmPassword ? 'text' : 'password'"
              outlined
              dense
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPassword = !showConfirmPassword"
              :rules="[v => !!v || $t('fill_all_fields'), v => v === newPassword || $t('passwords_dont_match')]"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="#1C1133"
            class="white--text px-6"
            elevation="2"
            block
            x-large
            @click="resetPassword()"
            :loading="loading"
            :disabled="loading || !isValidForm"
          >
            {{$t('reset_password')}}
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-snackbar color="#C00AC0" v-model="snackbarError" timeout="4000">
        {{snackbarErrorMessage}}
        <template v-slot:action="{ attrs }">
          <v-btn color="#1C1133" text v-bind="attrs" @click="snackbarError = false">{{$t('accept')}}</v-btn>
        </template>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import sharedMethods from '../../mixins/sharedMethods';

export default {
  name: 'ResetPassword',
  mixins: [sharedMethods],
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      loading: false,
      token: '',
      snackbarError: false,
      snackbarErrorMessage: '',
      valid: false,
      passwordRules: [
        v => !!v || this.$t('fill_all_fields')
      ]
    }
  },
  computed: {
    hasUpperCase() {
      return /[A-Z]/.test(this.newPassword);
    },
    hasLowerCase() {
      return /[a-z]/.test(this.newPassword);
    },
    hasNumber() {
      return /\d/.test(this.newPassword);
    },
    hasSpecialChar() {
      return /[$%&*@#?]/.test(this.newPassword);
    },
    hasLength() {
      return this.newPassword.length >= 12 && this.newPassword.length <= 24;
    },
    isValidForm() {
      return this.hasUpperCase &&
             this.hasLowerCase &&
             this.hasNumber &&
             this.hasSpecialChar &&
             this.hasLength &&
             this.newPassword === this.confirmPassword &&
             this.newPassword !== '';
    }
  },
  created() {
    // Obtener el token de la URL
    this.token = this.$route.query.token;
    if (!this.token) {
      this.$router.push('/');
    }
  },
  methods: {
    async resetPassword() {
      if (!this.isValidForm) {
        return;
      }

      this.loading = true;
      let formData = new FormData();
      formData.append("token", this.token);
      formData.append("new_password", this.newPassword);
      formData.append("action", "reset");

      try {
        const url = this.baseUrl + 'server/password_reset.php';
        const headers = { headers: { "Content-Type": "multipart/form-data" } };
        const result = await this.axios.post(url, formData, headers);

        if(result?.data?.code){
          this.validateCode(result?.data?.code)
        }

        if(result?.data?.bug){
          this.validateBug(result?.data?.bug)
        }
      } catch (error) {
        console.error(error);
        this.snackbarErrorMessage = this.$t('error_occurred');
        this.snackbarError = true;
      } finally {
        this.loading = false;
      }
    },
    validateCode(code){
      if(code == 200){
        this.snackbarErrorMessage = this.$t('password_reset_success')
        this.snackbarError = true

        setTimeout(() => {
          this.$router.push('/');
        }, 2000);

      }else if(code == 401){
        this.snackbarErrorMessage = this.$t('token_expired')
        this.snackbarError = true
      }else if(code == 404){
        this.snackbarErrorMessage = this.$t('token_not_found')
        this.snackbarError = true
      }else{
        this.snackbarErrorMessage = this.$t('error_occurred')
        this.snackbarError = true
      }
    },
    validateBug(bug){
      if(bug == 'BUG003'){
        this.snackbarErrorMessage = this.$t('password_used_recently')
        this.snackbarError = true
      }
    }
  }
}
</script>

<style scoped>
.fill-height {
  height: 100vh !important;
  background-color: #f5f5f5;
}
.password-requirements {
  border-radius: 4px;
  background-color: #f8f8f8;
  padding: 16px;
}
.password-checklist {
  background-color: transparent !important;
}
.v-list-item {
  min-height: 32px !important;
}
.primary--text {
  color: #1C1133 !important;
}
.v-card {
  border-radius: 8px;
  width: 100%;
}
.title-text {
  word-break: normal !important;
  overflow-wrap: break-word !important;
  hyphens: none !important;
  line-height: 1.2 !important;
  max-width: 100% !important;
  padding: 0 16px;
}
</style>
